<div class="eiq-grid-filter-bar">
  <div class="eiq-grid-filter-bar__container">
    <ng-content select="[slot=left-container]"></ng-content>
    <ng-content select="[slot=main-container]"></ng-content>
  </div>
  <div class="filter-box">
    <ng-content select="[slot=filter-box-container]"></ng-content>
    <eiq-search-input [formControl]="searchCtrl()" [placeholder]="searchPlaceholder()" [testId]="testId$() ? testId$() + '-search' : null"></eiq-search-input>
    <ng-content select="[slot=filter-box-actions]"></ng-content>

    @if (useAdvancedFilter()) {
      <eiq-button
        text="Filters"
        [color]="'light'"
        [style]="'stroked'"
        [icon]="faBarsFilter"
        [testId]="testId$() ? testId$() + '-filters' : null"
        (clicked)="openAdvancedFilter.emit()"
      >
        @if (numberOfFilterApplied() > 0) {
          <div slot="extended-text" class="filters-applied">
            <span class="fs__sm fw__600">{{ numberOfFilterApplied() }}</span>
          </div>
        }
      </eiq-button>
      @if (numberOfFilterApplied() > 0) {
        <eiq-button
          text="Clear Filters"
          [color]="'light'"
          [style]="'stroked'"
          [icon]="faClose"
          [testId]="testId$() ? testId$() + '-clear-filters' : null"
          (clicked)="clearAdvancedFilter.emit()"
        ></eiq-button>
      }
    }
  </div>
</div>
